export default __webpack_public_path__ + "assets/abous-us.ceca53de.png";